import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
// import axios from 'axios';
import axios from "../utils/axiosConfig";
import { Box, CircularProgress, Typography } from "@mui/material";
import { ResponsivePie } from "@nivo/pie";
import { ResponsiveBar } from "@nivo/bar";

const FinanceStatsById = ({ id }) => {
  const { t } = useTranslation(['common']);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const { data } = await axios.get(`/api/sales-documents/stats/${id}`);
        setStats(data);
      } catch (error) {
        console.error("Error fetching stats:", error);
      }
    };

    fetchStats();
  }, [id]);

  if (!stats) {
    return (<Box sx={{ display: 'flex', justifyContent: 'center', padding: '32px 24px' }}>
      <CircularProgress />
    </Box>);
  }

  const pieData = [
    { id: "Fees", label: t('common:fees'), value: stats.fees },
    { id: "Expenses", label: t('common:expenses'), value: stats.expenses },
    { id: "Provisions", label: t('common:provisions'), value: stats.provisions },
    { id: "VAT", label: t('common:vat'), value: stats.vat },
  ];

  const barData = [
    { category: t('common:paid'), value: stats.paid, color: "#FF6F61" }, // Coral
    { category: t('common:unpaid'), value: stats.unpaid, color: "#6B8E23" }, // Olive Green
    { category: t('common:credited'), value: stats.credited, color: "#FFD700" }, // Goldenrod
    { category: t('common:due_credit'), value: stats.dueCredit, color: "#40E0D0" }, // Turquoise
  ];

  const formatCurrency = (value) => `€${value.toFixed(2)}`;

  return (
    <Box>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-around"
        alignItems="center"
        sx={{ marginTop: "0px" }}
      >
        {/* Pie Chart */}
        <Box
          width="45%"
          height="50vh"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          {pieData.some((item) => item.value > 0) ? (
            <ResponsivePie
              data={pieData.filter((item) => item.value > 0)} // Only show non-zero values
              margin={{ top: 40, right: 50, bottom: 40, left: 50 }}
              innerRadius={0.5}
              padAngle={1}
              cornerRadius={3}
              colors={{ scheme: "pastel1" }}
              borderWidth={1}
              borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
              arcLabelsSkipAngle={10}
              arcLabel={(d) => `${d.label}: ${formatCurrency(d.value)}`}
              enableArcLinkLabels={true}
              arcLinkLabel={(d) => d.label}
              arcLinkLabelsSkipAngle={0}
              arcLinkLabelsTextColor="#333333"
              arcLinkLabelsThickness={2}
              arcLinkLabelsColor={{ from: "color" }}
              tooltip={({ datum: { label, value } }) => (
                <div
                  style={{
                    background: "white",
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                >
                  <strong>{label}</strong>: {formatCurrency(value)}
                </div>
              )}
            />
          ) : (
            <Typography
              variant="h6"
              sx={{
                color: "text.secondary",
                textAlign: "center",
                padding: 2,
              }}
            >
              {t('common:no_data_available')}
            </Typography>
          )}
        </Box>

        {/* Bar Chart */}
        <Box width="45%" height="50vh">
          <ResponsiveBar
            data={barData}
            keys={["value"]}
            indexBy="category"
            margin={{ top: 50, right: 50, bottom: 50, left: 80 }}
            padding={0.65}
            colors={({ data }) => data.color}
            valueFormat={(value) => formatCurrency(value)}
            axisBottom={{
              tickSize: 0,
              tickPadding: 5,
              legend: t('common:categories'),
              legendPosition: "middle",
              legendOffset: 32,
            }}
            axisLeft={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: t('common:amount_euro'),
              legendPosition: "middle",
              legendOffset: -60,
              format: (value) => `€${value}`,
            }}
            tooltip={({ id, value }) => (
              <div
                style={{
                  background: "white",
                  padding: "5px",
                  borderRadius: "5px",
                }}
              >
                <strong>{id}</strong>: {formatCurrency(value)}
              </div>
            )}
            theme={{
              tooltip: {
                container: {
                  background: "#fff",
                },
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default FinanceStatsById;
